import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_WATCHLIST_UPDATE_LOGS_COUNT } from '../types';
import { getWatchListUpdateLogsCountPending, getWatchListUpdateLogsCountFulfilled, getWatchListUpdateLogsCountRejected } from '../actions';
import {
  sendApiRequest,
  notifyWarning,
  notifyError,
} from '../../../actions';
import { WATCHLIST_UPDATE_LOG_MESSAGES } from '../constants/watchlistUpdateLogMessages';
import { watchListUpdateLogsFiltersSelector } from '../selectors';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'report/getwatchlistupdatelogscount',
  onSuccess: [
    response => (response.data === 0 ? notifyWarning(WATCHLIST_UPDATE_LOG_MESSAGES.NOT_FOUND) : { type: '' }),
    response => getWatchListUpdateLogsCountFulfilled(response),
  ],
  onError: [
    getWatchListUpdateLogsCountRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getWatchListUpdateLogsCountEpic$ = (action$, state$) => action$.pipe(
  ofType(GET_WATCHLIST_UPDATE_LOGS_COUNT.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = watchListUpdateLogsFiltersSelector(state$.value);

    return merge(
      of(getWatchListUpdateLogsCountPending()),
      of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
    );
  }),
);

export default getWatchListUpdateLogsCountEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/getWatchListUpdateLogsCountEpic.js